var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { height: "80%" } },
    [
      _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.userName))]),
      _vm._v(" "),
      _vm.clickItem.type === 1 && _vm.pageType === "2"
        ? _c("div", {
            staticClass:
              "icon iconfont icon-huanzhejilu-cu-fill more-icon-2 cursor",
            attrs: { id: "ris-button" },
            on: { click: _vm.risButtonClick }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.clickItem.type === 1
        ? _c("div", {
            staticClass: "iconfont icon-qunguanli more-icon cursor",
            attrs: { id: "setting-button" },
            on: {
              click: function($event) {
                return _vm.settingClick(true)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "content-micro" }, [
        _c(
          "div",
          { attrs: { id: "divContent" } },
          _vm._l(_vm.chatList, function(item, index) {
            return _c("div", { key: index }, [
              item.chatType === 0 && item.chatPosition === "left"
                ? _c("div", { staticClass: "left-chart one-chart" }, [
                    _c("div", {
                      staticClass: "avatar",
                      style:
                        "background:url(" +
                        (item.sendUser.avatarImageUrl
                          ? item.sendUser.avatarImageUrl
                          : require("../../../static/avatar.jpg")) +
                        ") 0 0 no-repeat;"
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "name-chart" }, [
                      _c("div", { staticClass: "left-name" }, [
                        _vm._v(_vm._s(item.sendUser.userName))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "chart-line" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(item.content) }
                        })
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              item.chatType === 0 && item.chatPosition === "right"
                ? _c("div", { staticClass: "right-chart one-chart" }, [
                    _c("div", { staticClass: "chart-line" }, [
                      _c("span", {
                        domProps: { innerHTML: _vm._s(item.content) }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "avatar",
                      style:
                        "background:url(" +
                        (item.sendUser.avatarImageUrl
                          ? item.sendUser.avatarImageUrl
                          : require("../../../static/avatar.jpg")) +
                        ") 0 0 no-repeat;"
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              item.chatType === 1 && item.chatPosition === "left"
                ? _c("div", { staticClass: "left-chart one-chart" }, [
                    _c("div", {
                      staticClass: "avatar",
                      style:
                        "background:url(" +
                        (item.sendUser.avatarImageUrl
                          ? item.sendUser.avatarImageUrl
                          : require("../../../static/avatar.jpg")) +
                        ") 0 0 no-repeat;"
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "name-chart" }, [
                      _c("div", { staticClass: "left-name" }, [
                        _vm._v(_vm._s(item.sendUser.userName))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "chart-line" }, [
                        _c(
                          "span",
                          [
                            _c("el-image", {
                              staticStyle: {
                                "max-width": "200px",
                                width: "auto",
                                height: "auto"
                              },
                              attrs: {
                                src: item.content,
                                "preview-src-list": _vm.imgList
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              item.chatType === 1 && item.chatPosition === "right"
                ? _c("div", { staticClass: "right-chart one-chart" }, [
                    _c("div", { staticClass: "chart-line" }, [
                      _c(
                        "span",
                        [
                          _c("el-image", {
                            staticStyle: {
                              "max-width": "200px",
                              width: "auto",
                              height: "auto"
                            },
                            attrs: {
                              src: item.content,
                              "preview-src-list": _vm.imgList
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "avatar",
                      style:
                        "background:url(" +
                        (item.sendUser.avatarImageUrl
                          ? item.sendUser.avatarImageUrl
                          : require("../../../static/avatar.jpg")) +
                        ") 0 0 no-repeat;"
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              item.chatType === 4 && item.chatPosition === "right"
                ? _c("div", { staticClass: "right-chart one-chart" }, [
                    _c(
                      "div",
                      {
                        staticClass: "chart-line cursor",
                        on: {
                          click: function($event) {
                            return _vm.voiceLineClick(item)
                          }
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "voice-block flex-right",
                            style: "width:" + item.width
                          },
                          [
                            _c("div", {
                              class: [
                                "trumpet",
                                "trumpet-right",
                                item.voicePlay ? "voicePlay" : ""
                              ]
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "inline-block" }, [
                              _vm._v(_vm._s(item.content.Time) + "s")
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "avatar",
                      style:
                        "background:url(" +
                        (item.sendUser.avatarImageUrl
                          ? item.sendUser.avatarImageUrl
                          : require("../../../static/avatar.jpg")) +
                        ") 0 0 no-repeat;"
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              item.chatType === 4 && item.chatPosition === "left"
                ? _c("div", { staticClass: "left-chart one-chart" }, [
                    _c("div", {
                      staticClass: "avatar",
                      style:
                        "background:url(" +
                        (item.sendUser.avatarImageUrl
                          ? item.sendUser.avatarImageUrl
                          : require("../../../static/avatar.jpg")) +
                        ") 0 0 no-repeat;"
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "name-chart" }, [
                      _c("div", { staticClass: "left-name" }, [
                        _vm._v(_vm._s(item.sendUser.userName))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "chart-line cursor",
                          on: {
                            click: function($event) {
                              return _vm.voiceLineClick(item)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "voice-block flex-left",
                              style: "width:" + item.width
                            },
                            [
                              _c("div", { staticClass: "inline-block" }, [
                                _vm._v(_vm._s(item.content.Time) + "s")
                              ]),
                              _vm._v(" "),
                              _c("div", {
                                class: [
                                  "trumpet",
                                  "trumpet-left",
                                  item.voicePlay ? "voicePlay" : ""
                                ]
                              })
                            ]
                          )
                        ]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              item.chatType === 9
                ? _c("div", { staticClass: "time-msg" }, [
                    _vm._v(_vm._s(item.createdTime))
                  ])
                : _vm._e(),
              _vm._v(" "),
              item.chatType === 2 && item.chatPosition === "right"
                ? _c("div", { staticClass: "right-chart one-chart" }, [
                    _c("span", { staticClass: "chart-line" }, [
                      _c(
                        "div",
                        { staticClass: "t-c file-box file-box-right" },
                        [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/file/" +
                                item.content.typeImg)
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "file-text" }, [
                            _c("div", { staticClass: "file-name" }, [
                              _vm._v(_vm._s(item.content.fileOriginName))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "file-size ft-l" }, [
                              _vm._v(_vm._s(item.content.fileSizeKb) + "KB")
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "inline-block ft-r",
                                attrs: { href: "javascript:void(0);" },
                                on: {
                                  click: function($event) {
                                    return _vm.downloadFile(
                                      item.content.id,
                                      item.content.fileOriginName
                                    )
                                  }
                                }
                              },
                              [_vm._v("下载附件")]
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "avatar",
                      style:
                        "background:url(" +
                        (item.sendUser.avatarImageUrl
                          ? item.sendUser.avatarImageUrl
                          : require("../../../static/avatar.jpg")) +
                        ") 0 0 no-repeat;"
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              item.chatType === 2 && item.chatPosition === "left"
                ? _c("div", { staticClass: "left-chart one-chart" }, [
                    _c("div", {
                      staticClass: "avatar",
                      style:
                        "background:url(" +
                        (item.sendUser.avatarImageUrl
                          ? item.sendUser.avatarImageUrl
                          : require("../../../static/avatar.jpg")) +
                        ") 0 0 no-repeat;"
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "name-chart" }, [
                      _c("div", { staticClass: "left-name" }, [
                        _vm._v(_vm._s(item.sendUser.userName))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "chart-line" }, [
                        _c("div", { staticClass: "t-c file-box" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/file/" +
                                item.content.typeImg)
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "file-text" }, [
                            _c("div", { staticClass: "file-name" }, [
                              _vm._v(_vm._s(item.content.fileOriginName))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "file-size ft-r" }, [
                              _vm._v(_vm._s(item.content.fileSizeKb) + "KB")
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "inline-block ft-l",
                                attrs: { href: "javascript:void(0);" },
                                on: {
                                  click: function($event) {
                                    return _vm.downloadFile(
                                      item.content.id,
                                      item.content.fileOriginName
                                    )
                                  }
                                }
                              },
                              [_vm._v("下载附件")]
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              item.chatType === 5
                ? _c("div", { staticClass: "other-msg" }, [
                    _c("span", [_vm._v(_vm._s(item.content))])
                  ])
                : _vm._e(),
              _vm._v(" "),
              item.chatType === 3 && item.chatPosition === "left"
                ? _c("div", { staticClass: "left-chart one-chart" }, [
                    _c("div", {
                      staticClass: "avatar",
                      style:
                        "background:url(" +
                        (item.sendUser.avatarImageUrl
                          ? item.sendUser.avatarImageUrl
                          : require("../../../static/avatar.jpg")) +
                        ") 0 0 no-repeat;"
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "name-chart" }, [
                      _c("div", { staticClass: "left-name" }, [
                        _vm._v(_vm._s(item.sendUser.userName))
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "chart-line",
                          staticStyle: {
                            "max-width": "360px",
                            "box-sizing": "border-box"
                          }
                        },
                        [
                          _c("div", { staticClass: "mb-10 line-height-25" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(item.content.comment) +
                                "\n                                "
                            ),
                            _c(
                              "a",
                              {
                                attrs: { href: "javascript:void(0);" },
                                on: { click: _vm.risButtonClick }
                              },
                              [_vm._v("详情>")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "file-box" }, [
                            _c("div", { staticClass: "ris-data" }, [
                              _c("img", {
                                attrs: {
                                  src: require("../../assets/" +
                                    item.content.img)
                                }
                              }),
                              _vm._v(" "),
                              _c("strong", { staticClass: "fs-15" }, [
                                _vm._v(_vm._s(item.content.patientName))
                              ]),
                              _vm._v(" "),
                              _c("div", {
                                class: "iconfont " + item.content.icon
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "fs-13" }, [
                                _vm._v(_vm._s(item.content.age))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "ris-content fs-15" }, [
                              _vm._v(_vm._s(item.content.projectName))
                            ])
                          ])
                        ]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              item.chatType === 3 && item.chatPosition === "right"
                ? _c("div", { staticClass: "right-chart one-chart" }, [
                    _c(
                      "span",
                      {
                        staticClass: "chart-line",
                        staticStyle: {
                          "max-width": "360px",
                          "box-sizing": "border-box"
                        }
                      },
                      [
                        _c("div", { staticClass: "mb-10 line-height-25" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(item.content.comment) +
                              "\n                            "
                          ),
                          _c(
                            "a",
                            {
                              attrs: { href: "javascript:void(0);" },
                              on: { click: _vm.risButtonClick }
                            },
                            [_vm._v("详情>")]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "file-box file-box-right" }, [
                          _c("div", { staticClass: "ris-data" }, [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/" + item.content.img)
                              }
                            }),
                            _vm._v(" "),
                            _c("strong", { staticClass: "fs-15" }, [
                              _vm._v(_vm._s(item.content.patientName))
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              class: "iconfont " + item.content.icon
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "fs-13" }, [
                              _vm._v(_vm._s(item.content.age))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "ris-content fs-15" }, [
                            _vm._v(_vm._s(item.content.projectName))
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "avatar",
                      style:
                        "background:url(" +
                        (item.sendUser.avatarImageUrl
                          ? item.sendUser.avatarImageUrl
                          : require("../../../static/avatar.jpg")) +
                        ") 0 0 no-repeat;"
                    })
                  ])
                : _vm._e()
            ])
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("audio", {
        staticClass: "hide",
        attrs: { id: "audioVoice", autoplay: "" }
      }),
      _vm._v(" "),
      _c("ky-preview-dialog", {
        attrs: {
          url: _vm.url,
          blob: _vm.blob,
          visible: _vm.visible,
          type: _vm.previewType
        },
        on: {
          "update:visible": function($event) {
            _vm.visible = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b73fcadc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b73fcadc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/chat/src/chat-content.vue
// module id = null
// module chunks = 